import { pb } from '@/lib/pocketbase';
import type { SimulatorState } from '@/domain/types';

type PublicSimulationResponse = {
  id: string;
  title: string;
  state: SimulatorState;
  updated: string | null;
};

function generateSlug(): string {
  return crypto.randomUUID().replace(/-/g, '').slice(0, 12);
}

export async function enablePublicShare(simulationId: string): Promise<string> {
  const current = await pb
    .collection('simulations')
    .getOne<{ publicSlug: string | null }>(simulationId);

  const slug = current.publicSlug || generateSlug();
  await pb.collection('simulations').update(simulationId, {
    publicEnabled: true,
    publicSlug: slug,
  });

  return `${window.location.origin}/p/${slug}`;
}

export async function disablePublicShare(simulationId: string): Promise<void> {
  await pb.collection('simulations').update(simulationId, { publicEnabled: false });
}

export async function fetchPublicSimulation(slug: string): Promise<PublicSimulationResponse> {
  const res = await fetch(pb.buildURL(`/api/public/simulations/${encodeURIComponent(slug)}`));
  if (!res.ok) {
    throw new Error('Simulation introuvable ou lien désactivé.');
  }
  return res.json() as Promise<PublicSimulationResponse>;
}
